import React, { useEffect } from 'react'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import Editor from 'ckeditor5-custom-build/build/ckeditor'
import { string, func, bool, object } from 'prop-types'
import { resizableCkeditorStylesForEditTemplate } from 'utils/ckeditorStylingDeffaults'
// import CKEditorInspector from '@ckeditor/ckeditor5-inspector'

const TemplateTextEditor = ({
	text,
	ckeditorStyles,
	ckeditorCss,
	onUpdateText,
	block,
	getEditor,
}) => {
	// inject the ckeditor css into the webpage
	useEffect(() => {
		const composedCss = ckeditorCss + resizableCkeditorStylesForEditTemplate

		const style = document.createElement('style')
		style.appendChild(document.createTextNode(composedCss))

		document.head.appendChild(style)

		// Clean-up function
		return () => {
			document.head.removeChild(style)
		}
	}, [ckeditorCss])

	return (
		<CKEditor
			onReady={(editor) => {
				getEditor(editor)
				// CKEditorInspector.attach(editor)
			}}
			editor={Editor}
			config={{
				style: ckeditorStyles,
			}}
			onChange={(event, editor) => onUpdateText(editor.getData(), 'text')}
			data={text}
			disabled={block}
		/>
	)
}

TemplateTextEditor.propTypes = {
	text: string,
	onUpdateText: func,
	block: bool,
	getEditor: func,
	ckeditorCss: string,
	ckeditorStyles: object,
}

export default TemplateTextEditor
